import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const UserGroupOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <G clipPath="url(#clip0_36_4552)">
      <Path
        d="M10 8.55837C11.4334 8.55837 12.6 7.3917 12.6 5.9667C12.6 4.5417 11.4334 3.3667 10 3.3667C8.56669 3.3667 7.40002 4.53337 7.40002 5.9667C7.40002 7.40003 8.56669 8.55837 10 8.55837ZM10 4.70003C10.7 4.70003 11.2667 5.2667 11.2667 5.9667C11.2667 6.6667 10.7 7.23337 10 7.23337C9.30002 7.23337 8.73336 6.6667 8.73336 5.9667C8.73336 5.2667 9.30002 4.70003 10 4.70003Z"
        fill={color}
      />
      <Path
        d="M10.8 8.9917H9.2C6.54167 8.9917 4.375 11.1584 4.375 13.8167V15.5334C4.375 16.2334 4.94167 16.8 5.64167 16.8H14.3583C15.0583 16.8 15.625 16.2334 15.625 15.5334V13.8167C15.625 11.1584 13.4583 8.9917 10.8 8.9917ZM14.2917 15.4667H5.70833V13.8167C5.70833 11.8917 7.275 10.325 9.2 10.325H10.8C12.725 10.325 14.2917 11.8917 14.2917 13.8167V15.4667Z"
        fill={color}
      />
      <Path
        d="M4.50833 10.325C5.60833 10.325 6.5 9.43334 6.5 8.33334C6.5 7.23334 5.60833 6.34167 4.50833 6.34167C3.40833 6.34167 2.51666 7.23334 2.51666 8.33334C2.51666 9.43334 3.40833 10.325 4.50833 10.325ZM4.50833 7.67501C4.86666 7.67501 5.16666 7.96667 5.16666 8.33334C5.16666 8.70001 4.875 8.99167 4.50833 8.99167C4.14166 8.99167 3.85 8.70001 3.85 8.33334C3.85 7.96667 4.14166 7.67501 4.50833 7.67501Z"
        fill={color}
      />
      <Path
        d="M15.6083 10.325C16.7083 10.325 17.6 9.43334 17.6 8.33334C17.6 7.23334 16.7083 6.34167 15.6083 6.34167C14.5083 6.34167 13.6166 7.23334 13.6166 8.33334C13.6166 9.43334 14.5083 10.325 15.6083 10.325ZM15.6083 7.67501C15.9666 7.67501 16.2666 7.96667 16.2666 8.33334C16.2666 8.70001 15.975 8.99167 15.6083 8.99167C15.2416 8.99167 14.95 8.70001 14.95 8.33334C14.95 7.96667 15.2416 7.67501 15.6083 7.67501Z"
        fill={color}
      />
      <Path
        d="M3.775 12.7833C3.91666 12.1083 4.18333 11.4833 4.54166 10.9333C2.86666 11.4083 1.64166 12.7583 1.64166 14.3667V15.9667C1.64166 16.425 2.03333 16.8 2.50833 16.8H3.65833V15.4667H2.975V14.3667C2.975 13.75 3.28333 13.2 3.775 12.7833Z"
        fill={color}
      />
      <Path
        d="M15.4833 10.9333C15.85 11.4917 16.1167 12.1083 16.25 12.7833C16.7417 13.1917 17.05 13.75 17.05 14.3667V15.4667H16.3667V16.8H17.5167C18 16.8 18.3833 16.425 18.3833 15.9667V14.3667C18.3833 12.7583 17.1583 11.4083 15.4833 10.9333Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="clip0_36_4552">
        <Rect width="20" height="20" fill={color} />
      </ClipPath>
    </Defs>
  </Svg>
)

export default UserGroupOutlined
